import { Col, Container, Row } from "react-bootstrap";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { WATCHLIST_GRID_INDEX } from "../../../utils/global_variables";
import { handleModal } from "../../../redux/actions/modals";

const PreTradeFailedScripsModal = ({ pretradeValidationFailedScrips, setBsePreTradeViolatingScrips, setBsePreTradeMsgAccepted }) => {
    const modals = useSelector(state => state?.modals?.modals);
    const dispatch = useDispatch();
    const handleNoClick = () => {
        dispatch(handleModal([{ "BSE_PRE_TRADE_WARNING_MODAL": false }]))
        setBsePreTradeViolatingScrips([]);
        setBsePreTradeMsgAccepted(false);
    }

    const handleYesClick = () => {
        dispatch(handleModal([{ "BSE_PRE_TRADE_WARNING_MODAL": false }]))
        setBsePreTradeMsgAccepted(true);
    }
    return (
        <div>
            <BzModal data-testid="ordercart-survmeasure-modal" size='sm' show={modals['BSE_PRE_TRADE_WARNING_MODAL']} className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='d-flex justify-content-start align-items-center'>
                                <div data-testid="ordercart-survmeasure-modal-title" className='font-medium font-size4 color-text'>BSE PRE TRADE VALIDATION</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <div className='font-regular font-size4 color-text mb-2'>Stop Loss order price range check failed for the below scrips. Do you still want to proceed?</div>
                        {
                            pretradeValidationFailedScrips.map(scrips => (
                                <Row className="g-0">
                                    <Col className='font-regular font-size4 color-text'>{scrips["SYMBOL"][WATCHLIST_GRID_INDEX.DISPLAY_DESC]}</Col>
                                </Row>
                            ))
                        }
                        <Row className='g-0 mt-2'>
                            <Col className='d-flex justify-content-start'>
                                <div className='font-regular font-size4 color-text'>Do you wish to continue?</div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0 justify-content-end'>
                            <Col md={10} className='d-flex align-items-center'>
                                <BzButton data-testid="ordercart-survmeasure-modal-no-button" className='btn btn-md btn-block btn-outline me-3' onClick={handleNoClick}>No</BzButton>
                                <BzButton data-testid="ordercart-survmeasure-modal-yes-button" className='btn btn-md btn-block btn-primary' onClick={handleYesClick}>Yes</BzButton>
                            </Col>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
        </div>
    )
}

export default PreTradeFailedScripsModal;